
  <input type="text" [(ngModel)]="_filterValue" (keyup)="onKeyUp()" />
